<div class="address-book-search">
    <button mat-raised-button
            type="button"
            class="alternative-button"
            (click)="openAddressBookSearchDialog($event)"
            [ngClass] = "{'french-button' : isLangFrench()}">
            {{'AddressBook'|translate}}
    </button>
</div>
